export default "__VITE_ASSET__BhsbdvUr__"